import { ContainerAcl } from 'app/models/ContainerAcl';

export interface ContainerAclGroupItem {
  value: ContainerAcl;
  label: string;
}

export interface ContainerAclGroup {
  key: string;
  title: string;
  items: ContainerAclGroupItem[];
}

export interface ContainerAclPreset {
  label: string;
  mask: number;
}

export const CONTAINER_ACL_GROUPS: ContainerAclGroup[] = [
  {
    key: "items",
    title: "Geozone permissions",
    items: [
      { value: ContainerAcl.ReadGeozone, label: "Read geozone" },
      { value: ContainerAcl.CreateGeozone, label: "Create geozone" },
      { value: ContainerAcl.EditGeozone, label: "Edit geozone" },
      { value: ContainerAcl.DeleteGeozone, label: "Delete geozone" },
    ]
  },
  {
    key: "drivers",
    title: "Driver permissions",
    items: [
      { value: ContainerAcl.ReadDriver, label: "Read driver" },
      { value: ContainerAcl.CreateDriver, label: "Create driver" },
      { value: ContainerAcl.EditDriver, label: "Edit driver" },
      { value: ContainerAcl.DeleteDriver, label: "Delete driver" }
    ]
  },
  {
    key: "driverKeys",
    title: "Driver key permissions",
    items: [
      { value: ContainerAcl.ReadDriverKey, label: "Read key/label" },
      { value: ContainerAcl.CreateDriverKey, label: "Create key/label" },
      { value: ContainerAcl.EditDriverKey, label: "Edit key/label" },
      { value: ContainerAcl.DeleteDriverKey, label: "Delete key/label" },
    ]
  },
  {
    key: "reportTemplates",
    title: "Report template permissions",
    items: [
      { value: ContainerAcl.ReadReportTemplate, label: "Read report template" },
      { value: ContainerAcl.CreateReportTemplate, label: "Create report template" },
      { value: ContainerAcl.EditReportTemplate, label: "Edit report template" },
      { value: ContainerAcl.DeleteReportTemplate, label: "Delete report template" },
    ]
  },
  {
    key: "container",
    title: "Container permissions",
    items: [
      { value: ContainerAcl.EditGroup, label: "Edit container" },
      { value: ContainerAcl.ManageMembers, label: "Manage members" },
      { value: ContainerAcl.DeleteContainer, label: "Delete container" }
    ],
  },
];

export function getContainerFullAccessMask(): number {
  return [
    ContainerAcl.ReadGeozone,
    ContainerAcl.CreateGeozone,
    ContainerAcl.EditGeozone,
    ContainerAcl.DeleteGeozone,
    ContainerAcl.ReadDriverKey,
    ContainerAcl.CreateDriverKey,
    ContainerAcl.EditDriverKey,
    ContainerAcl.DeleteDriverKey,
    ContainerAcl.ReadReportTemplate,
    ContainerAcl.CreateReportTemplate,
    ContainerAcl.EditReportTemplate,
    ContainerAcl.DeleteReportTemplate,
    ContainerAcl.EditGroup,
    ContainerAcl.ManageMembers,
    ContainerAcl.DeleteContainer,
    ContainerAcl.ReadDriver,
    ContainerAcl.CreateDriver,
    ContainerAcl.EditDriver,
    ContainerAcl.DeleteDriver,
  ].reduce((acc, v) => acc | v, 0);
}

export function getContainerAclPresets(): ContainerAclPreset[] {
  const fullMask = getContainerFullAccessMask();
  return [
    { label: "No access", mask: 0 },
    { label: "Full access", mask: fullMask }
  ];
}
